import type { ReactNode } from "react";
import { MarkdownLink } from "@/components/common/MarkdownLink";
import { openEnvironmentFileByPath } from "@/lib/environment-files";
import { filePathFromMarkdownHref } from "@/lib/markdown-file-link";

interface WorkspaceMarkdownLinkProps {
	href?: string;
	children?: ReactNode;
	/** 相対パスの基準にするワークスペース相対のディレクトリ。省略時はワークスペース直下。 */
	baseDir?: string;
	asPreview?: boolean;
}

/** Markdown のリンク。ワークスペースのファイルを指すものは右ペインで開き、それ以外は新しいタブで開く。 */
export function WorkspaceMarkdownLink({
	href,
	children,
	baseDir,
	asPreview,
}: WorkspaceMarkdownLinkProps) {
	const filePath = filePathFromMarkdownHref(href, baseDir);
	if (filePath === null) return <MarkdownLink href={href}>{children}</MarkdownLink>;

	// href を付けるとアプリの URL として解決され、中クリック等で 404 のページを開いてしまう。
	return (
		<a
			className="cursor-pointer text-accent underline"
			onClick={() => {
				openEnvironmentFileByPath(filePath, { asPreview }).catch((err: unknown) => {
					console.error("Failed to open linked file", err);
				});
			}}
		>
			{children}
		</a>
	);
}
